'use client';

import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { v4 as uuid } from 'uuid';
import { useAnalyticsPageView } from '../components/PageView/Context';
import { getCleanLocationHref } from '../lib/urlUtils';
import { EventName } from '../Shibuya';
import { useAnalytics } from './useAnalytics';
type UseElementViewedParams = {
  entityName: string;
  sectionName: string;
  additionalAttributes?: Record<string, unknown>;
};
export function useElementViewed({
  entityName,
  sectionName,
  additionalAttributes
}: UseElementViewedParams) {
  const {
    current: eventId
  } = useRef(uuid());
  const {
    analytics,
    deployableName,
    deployableVersion,
    gitSha
  } = useAnalytics();
  const {
    pageViewId,
    pageViewReady,
    pageName
  } = useAnalyticsPageView();
  const {
    ref,
    inView
  } = useInView({
    threshold: 0,
    rootMargin: '1px',
    triggerOnce: true
  });
  useEffect(() => {
    if (pageViewReady && inView && analytics) {
      void analytics.track(EventName.ELEMENT_VIEWED, {
        entity_name: entityName,
        section_name: sectionName,
        page_name: pageName,
        page_url: getCleanLocationHref(),
        pageview_id: pageViewId,
        event_id: eventId,
        deployable_name: deployableName,
        deployable_version: deployableVersion,
        additional_attributes: additionalAttributes
      }, {
        context: {
          app: {
            name: deployableName,
            version: gitSha
          }
        }
      });
    }
  }, [pageViewReady, inView]);
  return {
    ref,
    eventId
  };
}